import React, { useEffect, useState } from "react";
import SplitPane from "react-split-pane";
import VariableTableData from "./VariableTableData";
import VariableTableProperties from "./VariableTableProperties";
import VariableFilter from "./VariableFilter";
import UpdateVariable from "./UpdateVariable";
import { cdiscServices } from "../../../../../Services/CDISC/cdiscServices";
import UseToggle from "../../../../../Hooks/UseToggle";
import { useParams } from "react-router";
import {
  NoDataFoundTable,
  SpinerDataLoader,
} from "../../../../NoDataFoundTable/NoDataFoundTable";

const Variable = ({ onMouseDown, tableRef }) => {
  const [loader, setLoader] = useState(false);
  const { toggle, setToggle, toggle1, setToggle1 } = UseToggle();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [variableList, setVariableList] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState("");
  const [filter, setFilter] = useState(false);
  const { studyId } = useParams();

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getCDISCVariablesList = async () => {
    setLoader(true);
    let data = await cdiscServices.getCDISCVariablesList(studyId);
    setVariableList(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    getCDISCVariablesList();
  }, []);

  return (
    <div className={`code-list-container ${isFullScreen ? "full-screen" : ""}`}>
      <div className="p-1 hstack justify-content-between border-bottom toolbar">
        <div className="hstack gap-2">
          {isFormOpen && (
            <>
              <i
                title="Close Form"
                className="fa-solid fa-square-caret-left CP"
                onClick={() => setIsFormOpen("")}
              />
              <div className="vr"></div>
            </>
          )}
          <i
            title="Table Properties"
            className="fa-solid fa-list CP"
            onClick={setToggle}
          />
          <div className="vr"></div>
          <i
            className="fa-solid fa-filter"
            title="Filter"
            onClick={setToggle1}
          ></i>
        </div>
        {isFullScreen ? (
          <i
            className="fa-solid fa-maximize"
            title="Original Mode"
            onClick={toggleFullScreen}
          ></i>
        ) : (
          <i
            className="fa-solid fa-minimize"
            title="Full Mode"
            onClick={toggleFullScreen}
          ></i>
        )}
      </div>
      <div className="position-relative">
        <SplitPane
          split="horizontal"
          style={{
            height: isFullScreen ? "calc(100vh - 35px)" : "calc(100vh - 185px)",
          }}
          defaultSize={"100%"}
        >
          <SplitPane
            split="vertical"
            minSize={20}
            defaultSize={isFormOpen ? "20%" : "100%"}
          >
            {isFormOpen && (
              <UpdateVariable
                isFormOpen={isFormOpen}
                getCDISCVariablesList={getCDISCVariablesList}
                studyId={studyId}
              />
            )}
            <>
              {loader ? (
                <SpinerDataLoader />
              ) : variableList?.length === 0 ? (
                <NoDataFoundTable MSG={" Data Not Found!"} />
              ) : (
                <VariableTableData
                  studyId={studyId}
                  onMouseDown={onMouseDown}
                  tableRef={tableRef}
                  variableList={variableList}
                  setIsFormOpen={setIsFormOpen}
                  getCDISCVariablesList={getCDISCVariablesList}
                />
              )}
            </>
          </SplitPane>
        </SplitPane>
      </div>
      <VariableTableProperties
        Show={!toggle}
        Hide={setToggle}
        Title={"Table Properties"}
      />
      <VariableFilter
        Show={!toggle1}
        Hide={setToggle1}
        variableList={variableList}
        setVariableList={setVariableList}
        studyId={studyId}
        getCDISCVariablesList={getCDISCVariablesList}
        Title={"Filter Variable"}
        setFilter={setFilter}
        filter={filter}
      />
    </div>
  );
};

export default Variable;
